import {
	createRouter,
	createWebHashHistory
} from 'vue-router';


const routers = [{
		path: '/login',
		name: '登录',
		component: () => import('@/pages/login/index.vue'),
		hidden: true
	},
	{
		path: '/register',
		name: '注册',
		component: () => import('@/pages/register/index.vue'),
		hidden: true
	},
	{
		path: '/forget',
		name: '忘记密码',
		component: () => import('@/pages/forget/index.vue'),
		hidden: true
	},
	{
		path: '/onlineServe',
		name: '在线客服',
		component: () => import('@/pages/onlineServe/index.vue'),
		hidden: true
	},
	{
		path: '/',
		name: '首页',
		component: () => import('@/components/layout/index.vue'),
		meta: {
			title: '首页',
			icon: 'House'
		},
		children: [{
			path: '/',
			name: '首页',
			component: () => import('@/pages/index/index.vue')
		}]
	},
	{
		path: '/my',
		name: '我的',
		component: () => import('@/components/layout/index.vue'),
		meta: {
			title: '我的',
			icon: 'User'
		},
		children: [{
				path: '/myDevice',
				name: '我的云手机',
				component: () => import('@/pages/myDevice/index.vue')
			},
			{
				path: '/groupControlDevice',
				name: '云手机群控',
				component: () => import('@/pages/groupControlDevice')
			},
			{
				path: '/myGroup',
				name: '我的云手机分组',
				component: () => import('@/pages/myGroup/index.vue')
			},
			{
				path: '/myVpc',
				name: '我的Socks5代理',
				component: () => import('@/pages/myVpc/index.vue')
			},
			{
				path: '/parameter',
				name: '真机参数和指纹',
				component: () => import('@/pages/parameter/index.vue')
			},
			{
				path: '/userInfo',
				name: '我的账户',
				component: () => import('@/pages/userInfo/index.vue')
			}
		]
	},
	{
		path: '/invitation',
		name: '邀请返现',
		component: () => import('@/components/layout/index.vue'),
		meta: {
			title: '邀请返现',
			icon: 'Money'
		},
		children: [{
			path: '/invitation',
			name: '邀请返现',
			component: () => import('@/pages/invitation/index.vue')
		}]
	},
	{
		path: '/fileCenter',
		name: '文件中转站',
		component: () => import('@/components/layout/index.vue'),
		meta: {
			title: '文件中转站',
			icon: 'FolderOpened'
		},
		children: [{
			path: '/fileCenter',
			name: '文件中转站',
			component: () => import('@/pages/fileCenter/index.vue')
		}]
	},
	{
		path: '/shareText',
		name: '共享文本',
		component: () => import('@/components/layout/index.vue'),
		meta: {
			title: '共享文本',
			icon: 'Memo'
		},
		children: [{
			path: '/shareText',
			name: '共享文本',
			component: () => import('@/pages/shareText/index.vue')
		}]
	},
	// {
	// 	path: '/goldRecharge',
	// 	name: '充值享折扣',
	// 	component: () => import('@/components/layout/index.vue'),
	// 	meta: { title: '充值享折扣', icon: 'FolderOpened' },
	// 	children: [
	// 		{
	// 			path: '/goldRecharge',
	// 			name: '充值享折扣',
	// 			component: () => import('@/pages/goldRecharge/index.vue')
	// 		}
	// 	]
	// },
	{
		path: '/shop',
		name: '购买',
		component: () => import('@/components/layout/index.vue'),
		meta: {
			title: '购买',
			icon: 'Goods'
		},
		children: [{
				path: '/devStore',
				name: '购买云手机',
				component: () => import('@/pages/devStore/index.vue')
			},
			{
				path: '/renList',
				name: '云手机续费',
				component: () => import('@/pages/renList/index.vue')
			},
			{
				path: '/exchange',
				name: '兑换云手机',
				component: () => import('@/pages/exchange/index.vue')
			},
			{
				path: '/myOrder',
				name: '购买记录',
				component: () => import('@/pages/myOrder/index.vue')
			},
			{
				path: '/transfer',
				name: '转移记录',
				component: () => import('@/pages/transfer/index.vue')
			},
			{
				path: '/help',
				name: '帮助中心',
				component: () => import('@/pages/help/index.vue'),
				hidden: true
			}
		]
	}
]
const router = createRouter({
	history: createWebHashHistory(),
	base: process.env.BASE_URL,
	routes: routers
})
export default router